import React from "react";
import { useNavigate } from "react-router-dom";

function GeriButonu() {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate(-1)}
      style={{
        backgroundColor: "#6b7280", // gri
        color: "white",
        border: "none",
        padding: "10px 18px",
        fontSize: "15px",
        fontWeight: "500",
        borderRadius: "6px",
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        cursor: "pointer",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        transition: "background-color 0.2s ease",
      }}
      onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#4b5563")}
      onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#6b7280")}
    >
      ◀ Geri Dön
    </button>
  );
}

export default GeriButonu;
